const HIGH_CONTRAST_CHIP_COLORS = {
    primary: { color: '#12606B', bgcolor: '#DCF4FB' },
    secondary: { color: '#725300', bgcolor: '#FFF8E1' },
    success: { color: '#137333', bgcolor: '#E5FCEB' },
    error: { color: '#9B1C1C', bgcolor: '#FCE8E8' },
    orange: { color: '#8A3B12', bgcolor: '#FFF1E8' },
    warning: { color: '#6E5200', bgcolor: '#FFF8E1' }
};

export default HIGH_CONTRAST_CHIP_COLORS;
